import { useState, useMemo } from "react";

const allCities = [
  { name: "Portland", route: "/cities/portland-me", tagline: "Maine's largest city — expedited passport services", highlights: ["Cumberland County coverage", "Serving South Portland, Westbrook, Falmouth"], badge: "Most Popular", status: "live" },
  { name: "Bangor", route: "/bangor", tagline: "Northern Maine expedited passport hub", highlights: ["Penobscot County coverage", "Serving Brewer, Old Town, Orono"], badge: "Most Popular", status: "live" },
  { name: "Lewiston", route: "/cities/lewiston", tagline: "Androscoggin County expedited passport services", highlights: ["Twin Cities area coverage", "Serving Auburn, Lisbon, Sabattus"], badge: null, status: "live" },
  { name: "South Portland", route: "/cities/south-portland", tagline: "Cumberland County coastal passport services", highlights: ["South Portland area", "Serving Portland, Cape Elizabeth"], badge: null, status: "live" },
  { name: "Auburn", route: "/cities/auburn-me", tagline: "Androscoggin County passport processing", highlights: ["Auburn area coverage", "Serving Lewiston, Minot"], badge: null, status: "live" },
  { name: "Biddeford", route: "/cities/biddeford", tagline: "York County expedited passport services", highlights: ["Biddeford area coverage", "Serving Saco, Kennebunk, Arundel"], badge: null, status: "live" },
  { name: "Sanford", route: "/cities/sanford", tagline: "York County inland passport processing", highlights: ["Sanford area coverage", "Serving Springvale, Lebanon"], badge: null, status: "live" },
  { name: "Saco", route: "/cities/saco", tagline: "York County coastal passport services", highlights: ["Saco area coverage", "Serving Biddeford, Old Orchard Beach"], badge: null, status: "live" },
  { name: "Augusta", route: "/cities/augusta-me", tagline: "Kennebec County capital city passport services", highlights: ["Augusta area coverage", "Serving Manchester, Hallowell, Gardiner"], badge: null, status: "live" },
  { name: "Westbrook", route: "/cities/westbrook", tagline: "Cumberland County expedited passport processing", highlights: ["Westbrook area coverage", "Serving Portland, Gorham, Windham"], badge: null, status: "live" },
  { name: "Waterville", route: "/cities/waterville", tagline: "Kennebec County passport services", highlights: ["Waterville area coverage", "Serving Winslow, Fairfield"], badge: null, status: "live" },
  { name: "Presque Isle", route: "/cities/presque-isle", tagline: "Aroostook County northern Maine passport processing", highlights: ["Presque Isle area coverage", "Serving Caribou, Fort Fairfield"], badge: null, status: "live" },
  { name: "Ellsworth", route: "/cities/ellsworth", tagline: "Hancock County gateway to Acadia passport services", highlights: ["Ellsworth area coverage", "Serving Bar Harbor, Blue Hill"], badge: null, status: "live" },
  { name: "Old Town", route: "/cities/old-town", tagline: "Penobscot County expedited passport services", highlights: ["Old Town area coverage", "Serving Bangor, Orono, Milford"], badge: null, status: "live" },
  { name: "Brewer", route: "/cities/brewer", tagline: "Penobscot County passport processing across the river", highlights: ["Brewer area coverage", "Serving Bangor, Orono, Holden"], badge: null, status: "live" },
  { name: "Gardiner", route: "/cities/gardiner", tagline: "Kennebec County historic city passport services", highlights: ["Gardiner area coverage", "Serving Augusta, Randolph, Pittston"], badge: null, status: "live" },
  { name: "Bath", route: "/cities/bath", tagline: "Sagadahoc County shipbuilding city passport services", highlights: ["Bath area coverage", "Serving Brunswick, Topsham, Woolwich"], badge: null, status: "live" },
  { name: "Brunswick", route: "/cities/brunswick", tagline: "Cumberland County college town expedited passports", highlights: ["Brunswick area coverage", "Serving Topsham, Harpswell, Freeport"], badge: null, status: "live" },
  { name: "Scarborough", route: "/cities/scarborough", tagline: "Cumberland County coastal passport processing", highlights: ["Scarborough area coverage", "Serving South Portland, Cape Elizabeth, Gorham"], badge: null, status: "live" },
  { name: "Gorham", route: "/cities/gorham", tagline: "Cumberland County expedited passport services", highlights: ["Gorham area coverage", "Serving Westbrook, Windham, Buxton"], badge: null, status: "live" },
  { name: "Yarmouth", route: "/cities/yarmouth", tagline: "Cumberland County coastal passport services", highlights: ["Yarmouth area coverage", "Serving Freeport, Cumberland, Falmouth"], badge: null, status: "live" },
  { name: "Windham", route: "/cities/windham", tagline: "Cumberland County lakes region passport processing", highlights: ["Windham area coverage", "Serving Westbrook, Gorham, Raymond"], badge: null, status: "live" },
  { name: "Falmouth", route: "/cities/falmouth", tagline: "Cumberland County peninsula passport services", highlights: ["Falmouth area coverage", "Serving Portland, Yarmouth, Cumberland"], badge: null, status: "live" },
  { name: "Kennebunk", route: "/cities/kennebunk", tagline: "York County beach town expedited passports", highlights: ["Kennebunk area coverage", "Serving Kennebunkport, Arundel, Wells"], badge: null, status: "live" },
  { name: "Orono", route: "/cities/orono", tagline: "Penobscot County university town passport services", highlights: ["Orono area coverage", "Serving Bangor, Old Town, Veazie"], badge: null, status: "live" },
  { name: "Belfast", route: "/cities/belfast", tagline: "Waldo County coastal passport processing", highlights: ["Belfast area coverage", "Serving Searsport, Northport, Swanville"], badge: null, status: "live" },
  { name: "Rockland", route: "/cities/rockland", tagline: "Knox County lobster coast expedited passports", highlights: ["Rockland area coverage", "Serving Thomaston, Owls Head, Camden"], badge: null, status: "live" },
  { name: "Bar Harbor", route: "/cities/bar-harbor", tagline: "Hancock County Acadia gateway passport services", highlights: ["Bar Harbor area coverage", "Serving Ellsworth, Southwest Harbor, Tremont"], badge: null, status: "live" },
  { name: "Camden", route: "/cities/camden", tagline: "Knox County scenic harbor expedited passports", highlights: ["Camden area coverage", "Serving Rockport, Lincolnville, Hope"], badge: null, status: "live" },
  { name: "Freeport", route: "/cities/freeport", tagline: "Cumberland County outlet town passport services", highlights: ["Freeport area coverage", "Serving Brunswick, Yarmouth, Pownal"], badge: null, status: "live" },
  { name: "Topsham", route: "/cities/topsham", tagline: "Sagadahoc County bridge town passport processing", highlights: ["Topsham area coverage", "Serving Brunswick, Bath, Bowdoinham"], badge: null, status: "live" },
  { name: "York", route: "/cities/york-me", tagline: "York County southernmost coastal passport services", highlights: ["York area coverage", "Serving Kittery, Ogunquit, Wells"], badge: null, status: "live" },
  { name: "Wells", route: "/cities/wells", tagline: "York County beach town expedited passports", highlights: ["Wells area coverage", "Serving Kennebunk, Ogunquit, York"], badge: null, status: "live" },
  { name: "Cumberland", route: "/cities/cumberland-me", tagline: "Cumberland County rural passport processing", highlights: ["Cumberland area coverage", "Serving Falmouth, Yarmouth, North Yarmouth"], badge: null, status: "live" },
  { name: "Hampden", route: "/cities/hampden", tagline: "Penobscot County suburban passport services", highlights: ["Hampden area coverage", "Serving Bangor, Winterport, Newburgh"], badge: null, status: "live" },
  { name: "Ogunquit", route: "/cities/ogunquit", tagline: "York County art colony expedited passports", highlights: ["Ogunquit area coverage", "Serving Wells, York, Kennebunk"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function MaineCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Maine Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Maine Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Maine</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We're always adding new Maine locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}